import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import HamburgerIcon from './HamburgerIcon';
import FocusDropdown from './FocusDropdown';
import './Nav.css';

const simpleLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Our Story', to: '/our-story' },
  { label: 'Project Gallery', to: '/project-gallery' },
  { label: 'Contact Us', to: '/contact' },
];

function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 80);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      <Link to="/" className="nav-logo">
        <img src="/images/Stupa-primarylogo.png" alt="STUPA" className="nav-logo-img" />
        <span className="nav-logo-text">STUPA</span>
      </Link>
      <HamburgerIcon open={mobileOpen} onClick={() => setMobileOpen(!mobileOpen)} />
      <ul className={`nav-links ${mobileOpen ? 'show' : ''}`}>
        {simpleLinks.slice(0, 2).map((l) => (
          <li key={l.label}><Link to={l.to} onClick={closeMobile}>{l.label}</Link></li>
        ))}
        <FocusDropdown onNavigate={closeMobile} />
        {simpleLinks.slice(2).map((l) => (
          <li key={l.label}><Link to={l.to} onClick={closeMobile}>{l.label}</Link></li>
        ))}
        <li>
          <Link to="/contact" className="nav-cta" onClick={closeMobile}>Enquire Now</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
